import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { Button } from "@/components/ui/button";
import { Bell, ArrowLeft } from "lucide-react";

const RemindersPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="container max-w-2xl mx-auto py-8 animate-in fade-in duration-500">
        <div className="flex flex-col items-center justify-center min-h-[60vh] text-center space-y-6">
          <div className="w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center">
            <Bell className="h-10 w-10 text-primary-strong" />
          </div>
          <div className="space-y-2">
            <h1 className="text-3xl font-bold tracking-tight text-foreground">Bald verfügbar</h1>
            <p className="text-muted-foreground max-w-md">
              Automatische WhatsApp-Erinnerungen an Ihre Kunden werden bald verfügbar sein. Wir arbeiten daran!
            </p>
          </div>
          <Button
            variant="outline"
            onClick={() => navigate('/dashboard')}
            className="mt-4"
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Zurück zur Übersicht
          </Button>
        </div>
      </div>
    </Layout>
  );
};

export default RemindersPage;
